import { Box, Typography } from '@mui/material';
import { DirectShearResultEntry } from './direct-shear/DirectShearResultEntry';
import { TEST_CODES } from '../../../constants/testCodes';

interface ResultEntryRouterProps {
  /** Stable Test.TestCode (BUG-2026-0197) — dispatch key, not the display name. */
  testCode: string | null;
  directShearGeneralKey?: string;
  savedDilationRange?: number | null;
  /** Per-stage dilation windows keyed by stage number (BUG-2026-0211); null = never calculated. */
  stageDilationRanges?: Record<number, number | null>;
  onCalculated?: () => void;
  readOnly?: boolean;
}

export const ResultEntryRouter = ({ testCode, directShearGeneralKey, savedDilationRange, stageDilationRanges, onCalculated, readOnly }: ResultEntryRouterProps) => {
  switch (testCode) {
    case TEST_CODES.directShear:
      if (!directShearGeneralKey) {
        return (
          <Box sx={{ py: 6, textAlign: 'center' }}>
            <Typography color="text.secondary">Save test parameters first to enable result entry.</Typography>
          </Box>
        );
      }
      return (
        <DirectShearResultEntry generalKey={directShearGeneralKey} savedDilationRange={savedDilationRange}
          stageDilationRanges={stageDilationRanges} onCalculated={onCalculated} readOnly={readOnly} />
      );

    default:
      return (
        <Box sx={{ py: 6, textAlign: 'center' }}>
          <Typography color="text.secondary">
            Result Entry is not yet available for this test type.
          </Typography>
        </Box>
      );
  }
};
